<!--banner-->
<div class="relative w-full h-[768px]">
  <!-- Desktop image -->
  <img src="/png/[Lead-gen]-Website-banner-for-Asahi-lead-flow.png"
       alt="Background"
       class="w-full h-full object-cover hidden sm:block" />
  <!-- Mobile image -->
  <img src="/png/mobile-Version.png"
       alt="Background Mobile"
       class="w-full h-full object-cover block sm:hidden" />
  <!-- ✅ Updated Overlay Layout (Centered like Car Insurance) -->
  <div class="absolute inset-0 max-w-[1200px] mx-auto w-full
              flex flex-col items-start justify-start sm:justify-center
              px-[20px] sm:gap-[25px] gap-4 pt-[100px] sm:pt-[0px]">
    <h1 class="text-white font-[Manrope]
               text-[32px] sm:text-[50px] font-bold
               leading-[40px] sm:leading-[76px]
               tracking-[-0.496px] md:w-[586px]">
      {{'Secure Your Finances - Embrace Lasting Peace of Mind' | translate}}
    </h1>
    <p class="text-white font-[Manrope]
              text-[16px] sm:text-[20px] font-normal
              leading-normal max-w-[579px]">
      {{'Your shield against unforeseen risks and income interruptions' | translate}}
    </p>
    <div (click)="scrollToForm()"
         class="flex justify-center items-center p-4 gap-[9px] self-stretch
                w-[200px] sm:w-[300px] max-w-[600px]
                rounded-[90px] bg-[#2AD189] hover:bg-[#A4FFD6]
                cursor-pointer transition-colors duration-300">
      <span class="text-[16px] sm:text-[20px] font-[Manrope] font-bold text-black leading-normal">
        {{ 'REGISTER NOW' | translate }}
      </span>
    </div>
  </div>
</div>
